export default __webpack_public_path__ + "static/media/SimplifyHire.602a2c62.svg";